import React from "react";

const ShieldCell = (rowData) => {
  if (!rowData.context || !(rowData.context || {}).shield) return null;
  return (
    <React.Fragment>
    <span className="p-column-title">Shield</span>    
      <span>{rowData.context.shield.device_score}</span>
      <br />
      {rowData.context.shield.is_anti_fingerprinting && (
        <img
          src="/images/anti-fingerprint.png"
          style={{ width: "20px" }}
          alt="anti-fingerprinting"
        />
      )}
      {rowData.context.shield.is_incognito && (
        <img
          src="/images/incognito.png"
          style={{ width: "20px" }}
          alt="incognito"
        />
      )}
      {rowData.context.shield.is_proxy && (
        <img src="/images/proxy.png" style={{ width: "20px" }} alt="Proxy" />
      )}
      {rowData.context.shield.is_emulated && (
        <img
          src="/images/emulated.png"
          style={{ width: "20px" }}
          alt="Emulated"
        />
      )}
    </React.Fragment>
  );
};

export default ShieldCell;
